import React from 'react';
import { SuggestTextCellEditor } from '@ui/text';
import { AutodocType, coreActions } from '@sonar-software/sonar-core';
import { useAction, useSonarObjectReference } from '@hooks';
export const DefinitionColumn = ({ sonarObjectId, getPopupContainer }) => {
    var _a, _b, _c;
    const definition = (_c = (_b = (_a = useSonarObjectReference(sonarObjectId)) === null || _a === void 0 ? void 0 : _a.context) === null || _b === void 0 ? void 0 : _b.definition) !== null && _c !== void 0 ? _c : '';
    const updateSonarObjectContext = useAction(coreActions.requestPatchCoreSonarObjectsContext);
    const handleSave = (content) => {
        updateSonarObjectContext({
            context: { definition: content },
            sonarObjectId
        });
    };
    return (React.createElement(SuggestTextCellEditor, { autodocType: AutodocType.Definition, canBeEmpty: true, getPopupContainer: getPopupContainer, onSave: handleSave, sonarObjectId: sonarObjectId, value: definition }));
};
